module.exports = __webpack_public_path__ + "static/media/a3lg.076b6dc1.png";